import React from "react";
import Select, { components } from "react-select";

const CustomOption = (props: any) => {
  const { data, innerRef, innerProps } = props;

  const items = data.label.split(":::")
  let label1 = ""
  let label2 = ""
  if(items.length == 2) {
    label1 = items[0]
    label2 = items[1]
  }

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="custom-select__option flex lg:flex-row lg:items-center md:flex-col "
    >
      <span className="font-bold text-base alu-text-base-2">{label1}</span>
      <span className="lg:ml-3 text-xs font-normal alu-text-base-1">
        {label2}
      </span>
    </div>
  );
};

const DefaultOption = (props: any) => {
  const { data, innerRef, innerProps } = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="custom-select__option flex lg:flex-row lg:items-center md:flex-col"
    >
      <span className="text-sm alu-text-base-2">{data.label}</span>
    </div>
  );
};

const ClearIndicator = (props: any) => {
  const {
    children = (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1334_12593)">
          <path d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z" fill="currentColor"/>
        </g>
        <defs>
          <clipPath id="clip0_1334_12593">
            <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    ),
    getStyles,
    innerProps,
    isFocused
  } = props;

  return (
    <div
      {...innerProps}
      style={getStyles("clearIndicator", props)}
      onMouseEnter={(e) => e.stopPropagation()}
      className={`cursor-pointer h-5 w-5 rounded-full !p-0 justify-center items-center mr-2 hover:bg-[#FFF3E5] !text-[#808080] hover:!text-[#FF861A] active:!bg-[#FFF3E5] active:!text-[#B35400] focus:!bg-transparent focus:!outline focus:!outline-1 focus:!outline-[#FF861A] focus:!text-[#808080]`}
    >
      {children}
    </div>
  );
};

const CustomMenuList = (props: any) => (
  <components.MenuList {...props}>
    <div className="custom-scrollbar">
      {props.children}
    </div>
  </components.MenuList>
);

interface CustomAutoCompleteProps {
  isCustomOption?: boolean;
  options: any;
  onChange: (item: any) => void;
  placeholder: string;
  inputValue: any;
  onInputChange: (value: any) => void;
  value?: any;
  noOptionsMessage?: string,
  isClearable?: boolean;
  menuPlacement?: 'auto' | 'top' | 'bottom';
  controlHeight?: number
}
const CustomAutoComplete: React.FC<CustomAutoCompleteProps> = ({
  isCustomOption = true,
  options,
  onChange,
  placeholder,
  inputValue,
  onInputChange,
  value=null,
  noOptionsMessage = '検索条件に一致する結果が見つかりませんでした。',
  isClearable = false,
  menuPlacement = 'auto',
  controlHeight = 36
}) => {
  return (
    <Select
      className="custom-react-select"
      classNamePrefix={"custom-select"}
      options={options}
      value={value}
      noOptionsMessage={() => noOptionsMessage}
      inputValue={inputValue}
      components={{ Option: isCustomOption ? CustomOption : DefaultOption, ClearIndicator, MenuList: CustomMenuList }}
      placeholder={placeholder}
      onChange={onChange}
      onInputChange={onInputChange}
      isClearable={isClearable}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menuList: (base) => ({
          ...base,
          overflowY: "auto",
          scrollbarWidth: "thin", // Firefox
          scrollbarColor: "#D9D9D9 #F7F7F7;", // Firefox
        }),
        control: (base, state) => ({
          ...base,
          minHeight: controlHeight,
          "&:hover": !state.hasValue
            ? { borderColor: "#transparent !important", backgroundColor: "#FFF3E5 !important" }
            : { backgroundColor: "transparent !important", borderColor: "#E0E0E0 !important" },
        }),
        noOptionsMessage: (base) => ({
          ...base,
          fontSize: "14px"
        })
      }}
      menuPlacement={menuPlacement}
    />
  );
};

export default CustomAutoComplete;
